<template>
  <footer class="footer">
    <div class="main-wrapper__footer row is-desctop">
      <div class="offset-md-1 col-foot col">
        <div class="item_in-col logo-wrapper">
          <a href="/">
            <img src="/static/img/logo_full.svg" style="max-width:100%; width: 100%;" />
          </a>
        </div>
        <div class="item_in-col">
          <img class="img-soc" src="/static/img/icon_phone.svg" />
          <a href="tel:+74956425292">+7 (495) 64 25 292</a>
        </div>
        <div class="item_in-col">
          <img class="img-soc" src="/static/img/icon_mail_dark.svg" />
          <a href = "mailto: info@mobileadvokat.ru">info@mobileadvokat.ru</a>
        </div>
        <div class="item_in-col wrapper-icons-social">
          <a href="https://wa.me/79910830833" style="display: flex;">
            <img
              style="width: 36px;"
              src="/static/img/icon_whatsapp_black.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://vk.com/mob_advokat">
            <img
              style="width: 50px;"
              src="/static/img/vk-02-01.svg"
              class="margin-right-1"
            />
          </a>
          <a href="https://www.youtube.com/channel/UCOyKsErmFTcl23B2ckPA0MQ">
            <img
              style="width: 50px;"
              src="/static/img/you-02-01.svg"
              class="margin-right-1"
            />
          </a>
        </div>
      </div>
      <div class="col-foot col">
        <div class="item_in-col">
          <ui_sub_title_text>О сервисе:</ui_sub_title_text>
        </div>
        <div class="item_in-col">
          <router-link to="/work">Как это работает?</router-link>
        </div>
        <div class="item_in-col">
          <router-link to="/privacy">Политика конфиденциальности</router-link>
        </div>
        <div class="item_in-col">
          <a href="/static/doc/offerta.pdf" target="_blank">Условия использования</a>
        </div>
      </div>
      <div class="col-foot col">
        <div class="item_in-col">
          <ui_sub_title_text>Клиентам:</ui_sub_title_text>
        </div>
        <div class="item_in-col">
          <router-link to="/safety">Безопасная сделка</router-link>
        </div>
        <div class="item_in-col">
          <router-link to="/search">Найти адвоката</router-link>
        </div>
        <div class="item_in-col">
          <router-link to="/privacy">Политика конфиденциальности</router-link>
        </div>
        <div class="item_in-col">
          <button  v-on:click="toApplying" style="border: none !important; outline: none !important;">Срочная помощь адвоката</button>
        </div>
      </div>
      <div class="col-foot col">
        <div class="item_in-col">
          <ui_sub_title_text>Адвокату:</ui_sub_title_text>
        </div>
        <div class="item_in-col">
          <router-link to="/insurance">Страхование</router-link>
        </div>
      </div>
    </div>
    <div class="is-mobile">
      <div class="red-line"></div>
      <div class="list-button">
        <div class="button-set-footer" @click="setList('service')" :class="setFooter === 'service' ? 'button-set-footer__active' : ''">
          О сервисе
        </div>
        <div class="button-set-footer" @click="setList('advocate')" :class="setFooter === 'advocate' ? 'button-set-footer__active' : ''">
          Адвокату
        </div>
        <div class="button-set-footer" @click="setList('client')" :class="setFooter === 'client' ? 'button-set-footer__active' : ''">
          Клиенту
        </div>
      </div>
      <div v-if="itemsList.length > 0" class="list-open  animate__animated animate__fadeInLeft">
        <div v-for="item in itemsList" :key="'list'+item.name" class="item">
          <router-link :to="item.href" v-if="item.href !== '/static/doc/offerta.pdf'">{{item.name}}</router-link>
          <a target="_blank" v-else :href="item.href">{{item.name}}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    isService: false,
    isClient: false,
    isAdvocat: false,
    itemsList: [],
    setFooter: ''
  }),
  methods: {
    setList(name){
      if(this.setFooter === name){
        this.setFooter = null
        this.itemsList = []
        return
      }
      this.setFooter = name
      switch (name) {
        case 'client':
          this.itemsList = [
            {
              name: 'Безопасная сделка',
              href: '/safety'
            },
            {
              name: 'Найти адвоката',
              href: '/search'
            },
            {
              name: 'Политика конфиденциальности',
              href: '/privacy'
            },
          ]
          this.scrollToBottom()
          return ''
        case 'advocate':
          this.itemsList = [
            {
              name: 'Страхование',
              href: '/insurance'
            },
          ]
          this.scrollToBottom()
          return ''
        case 'service':
          this.itemsList = [
            {
              name: 'Как это работает?',
              href: '/work'
            },
            {
              name: 'Политика конфиденциальности',
              href: '/privacy'
            },
            {
              name: 'Условия использования',
              href: '/static/doc/offerta.pdf'
            },
          ]
          this.scrollToBottom()
          return ''
      }
    },
    reg(){
      this.$root.$emit('modal.reg');
    },
    login(){
      this.$root.$emit('modal.auth');
    },
    toHelp(){
      this.$root.$emit('modal.help');
    },
    toApplying(){
      this.$root.$emit('modal.applying');
    },
    scrollToBottom(){
      this.$root.$emit('all.scroll.bottom');
      this.$nextTick(() => {
        $('html')[0].scrollTo(0, document.body.scrollHeight);
      })
        try {
            $('html')[0].scrollTo(0, document.body.scrollHeight);
            // $('#app-content').scrollToBottom(0);
            // $('#app-content_mobile').scrollToBottom(0);
            // this.myScrollContainer.nativeElement.scrollTop = this.myScrollContainer.nativeElement.scrollHeight;
        } catch(err) { }
    }
  },
  computed: mapGetters([]),
};
</script>


<style scoped>
  .footer {
    font-family: 'Helvetica';
    background-color: #FFFFFF !important;
    padding-top: 90px;
    padding-bottom: 50px;
  }

  .logo-wrapper{
    margin-bottom: 50px;
    margin-left: -16px;
  }

  .item_in-col:not(:first-child){
    margin-top: 8px;
  }

  .ui-sub-title-text:first-child:before {
    content : "";
    position: absolute;
    left    : 0;
    bottom  : 0;
    height  : 1px;
    width   : 90px;  /* or 100px */
    border-bottom: 1px solid #D34646;
  }

  .item_in-col .img-soc{
    margin-right: 19px;
  }

  .item_in-col{
    position: relative;
    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 131.5%;

    color: #000000;
  }

  .wrapper-icons-social{
    display: flex;
  }
  @media (min-width: 850px) {
    .footer {
      padding-left: 60px;
    }
  }
  @media (max-width: 850px) {

    .list-button{
      display: flex;
      justify-content: space-between;
    }
    .list-button .button-set-footer{
      background: #D9D9D9;
      border-radius: 20px;
      padding: 0.5em 1em;
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 19px;
    }
    .list-button .button-set-footer__active{
      background: #FFFFFF;
    }
    .footer {
      padding: 11px 24px;
    }
    .red-line{
      border: 1px solid rgb(152, 16, 16);
      margin-bottom: 10px;
      width: 30%;
    }
    .list-open .item{
      font-family: 'Helvetica';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 100%;
      color: #000000;
      padding: 5px 0;
    }
    .list-open{
      background: #D9D9D9;
      border-radius: 0px 20px 20px 0px;
      max-width: 64%;
      margin-top: 5px;
      padding: 5px 16px;
      margin-left: -22px;
    }
  }
</style>



// WEBPACK FOOTER //
// footer.vue?a80ae258